import React from "react";
import {Navbar,Footer,Sidebar} from '../medicalcomponents';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import {useParams,Link} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { format } from "date-fns";
import { medecinComp, medecinuom } from '../utils/datalist';
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";

const IssueReport=()=>{

    if (localStorage.getItem('branchID') === null) {
    window.location.replace('/');
    }

    const [itemData,setItemData]=useState([]);
    const [noResults, setNoResults] = useState(false);
    const [empData,setEmpData]=useState([]);
    const [empSearch,setEmpSearch]=useState();
    const [empID, setEmpId] = useState("");
    const [filterEmp, setFilterEmp] = useState([]);

    useEffect(() => {
    const getAssetData = async () => {
          const res=await axios.get(configData.SERVER_URL+`/empData/${localStorage.getItem('branchID')}`);
          setEmpData(res.data);
          setFilterEmp(res.data);
    };
    getAssetData();
  }, []);

    const [startDate, setStartDate] = useState(() => {
            const today = new Date();
            return today.toISOString().split('T')[0];
            });

    const [endDate, setEndDate] = useState(() => {
            const today = new Date();
            return today.toISOString().split('T')[0];
            });

    const filterEmployee=(e)=>{
        const value = e.target.value.toLowerCase(); 
        setEmpSearch(value);
        const updatedList = empData.filter(emp =>
        emp.empCode?.toLowerCase().includes(value) ||
        emp.empName?.toLowerCase().includes(value) 
        );
        setFilterEmp(updatedList);
    }

    const handleSubmit=async(e)=>{
    e.preventDefault();

    if (!startDate || !endDate) {
        alert('Dates required.');
        return;
    }   

    try {
      const res = await axios.get(configData.SERVER_URL+`/issueEmpDateRange/${startDate}/${endDate}/${localStorage.getItem('branchID')}/${empID}`);
      setItemData(res.data);      

      if (res.data.length === 0) {
        setNoResults(true);
      } else {
        setNoResults(false);
      }
    } catch (error) {
      console.error('Search error:', error);
    }   
    }

    return(
        <>

        <div className="container-fluid">
            <div className="card bg-info "> 
                <div className="card-header d-flex justify-content-between align-items-center"
                  style={{
                  background: "linear-gradient(135deg, #0d6efd, #0dcaf0)",
                  color: "#fff",
                  padding: "18px 25px",
                  border: "none",
                  }} >
                  <div>
                    <h3 className="mb-0 fw-bold">Item Issue to Employee</h3>
                  </div>
                </div>
                    <div className="card-body" style={{backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px"}}>
                        
                        <div className="col-lg-3">
                            <label>Employee</label>
                            <Select options={filterEmp.map(d => ({ value: d.id, label: d.empCode+':'+d.empName }))} isSearchable 
                                placeholder="Select Employee..."
                                onChange={(selectedOption) => {
                                    if (selectedOption) {
                                    setEmpId(selectedOption.value);   // store ID
                                    } else {
                                    setEmpId(null);
                                    }
                                }}
                            />
                        </div>

                        <div className="col-lg-3">
                                            <label>Date From</label>
                                            <input type="date" className="form-control" name="sDate" id="sDate" value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}></input>
                                        </div>

                        <div className="col-lg-3">
                                            <label>Date To</label>
                                            <input type="date" className="form-control" name="eDate" id="eDate" value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}></input>
                                        </div>

                        <div className="col-lg-2">
                                            <br></br>
                                            <button type="button" class="btn btn-info">
                                                <span class="glyphicon glyphicon-search" onClick={(e)=>{handleSubmit(e)}}><Icon.Search/></span>
                                            </button>
                                        </div>
                    </div>

                    {noResults && <p class="text-center" >No results found.</p>}

                    <div className="card-body" style={{backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px"}}>
                        <div className="table-responsive-sm table-responsive-md table-responsive-lg table-responsive-sl table-responsive-xxl">
                        <table class="table table-success table-hover table-bordered">
                            <thead>
                                <tr>
                                <th>#</th>
                                <th>Item Code & Name</th>
                                <th>Issue Qty</th>
                                <th>Unit</th>
                                <th>Price</th>
                                <th>Total Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                    {
                                    itemData && itemData.length>0 && itemData.map((data,i)=>
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td align="left">{data.itemCode}:{data.itemName}</td>
                                        <td align="left">{data.issueQty}</td>
                                        <td align="left">{data.uom}</td>
                                        <td align="left">{data.itemPrice}</td>
                                        <td align="left">{data.totalAmount}</td>
                                    </tr>
                                    )} 
                            </tbody>
                        </table>
                        </div>
                    </div>
            </div>
        </div>
        </>
    )
}

export default IssueReport;
